import { editStoreBuilder } from '@/main/store/pages/edit/builder';


import { CRUMB_LABEL_EDIT, NAME } from '../constants';
import { apiProvider } from '../api';

const edit = {
	Id: 0 as number | string,
	FirstName: null as string | null,
	LastName: null as string | null,
	DealerKVPS: null as string | null,
	DealerName: null as string | null,
	EmailAddress: null as string | null,
	IsFollowupRequired: true as boolean | null,
	PracovnikId: null as number | null,
	PracovnikOzn: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_EDIT,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
